var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.49 190.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.22,128.51l239.58-15.94c.17-.01.34-.02.52-.01l193.88,6.22c3.47.08,6.11,3.16,5.64,6.61l-7.98,58.47c-.68,4.98,4.85,8.42,9.02,5.62l127.05-85.54c3.56-2.4,3.39-7.7-.33-9.86L434.76,13.38c-5.4-3.14-11.29,3.29-7.68,8.39l19.58,27.71c3.05,4.32-.77,10.14-5.95,9.06L247.94.12c-.55-.11-1.11-.15-1.66-.1L8.57,19.24c-4.68.38-7.01,5.87-4.03,9.5l36.28,44.11c1.92,2.33,1.73,5.74-.42,7.86L1.76,118.54c-3.86,3.78-.93,10.32,4.46,9.97Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bdb5244fc92391b3741e2719fd3c0e8f.svg";
export { ForwardRef as ReactComponent };